import { render, staticRenderFns } from "./CareServiceCreate.vue?vue&type=template&id=2d0f5143&scoped=true"
import script from "./CareServiceCreate.vue?vue&type=script&lang=js"
export * from "./CareServiceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f5143",
  null
  
)

export default component.exports